export const adminDashboardAr = {
  // Navigation
  greeting: 'مرحباً',
  adminDashboard: 'لوحة المدير',
  home: 'الرئيسية',
  dashboard: 'لوحة التحكم',
  students: 'الطلاب',
  teachers: 'الأساتذة',
  inscriptionRequests: 'طلبات التسجيل',
  contactMessages: 'التواصل الخارجي',
  allStatuses: 'جميع الحالات',
  allTypes: 'جميع الأنواع',
  allSchoolYears: 'جميع السنوات',
  writeReply: 'ردّك هنا...',
  archive: 'أرشفة',
  reply: 'رد',
  send: 'إرسال',
  approved: 'مقبول',
  rejected: 'مرفوض',
  reviewed: 'قيد المراجعة',
  registered: 'مسجّل',
  pending: 'قيد الانتظار',
  parent: 'ولي أمر',
  teacher: 'أستاذ',
  statusNew: 'جديد',
  statusRead: 'مقروء',
  statusReplied: 'تم الرد',
  statusArchived: 'مؤرشف',
  registerParent: 'تسجيل ولي أمر',
  registerChildren: 'تسجيل الأبناء',
  viewParent: 'عرض ملف الوالد في أولياء الأمور',
  requests: 'طلبات',
  details: 'التفاصيل',
  linkedAccount: 'الحساب المرتبط',
  children: 'الأبناء',
  child: 'طفل',
  reviewerNotes: 'ملاحظات المراجع',
  by: 'بقلم',
  notRegistered: 'غير مسجل',
  reEnroll: 'إعادة تسجيل',
  studentsParents: 'الطلاب وأولياء الأمور',
  administration: 'الإدارة',
  manageTeachers: 'إدارة الأساتذة',
  quranTracking: 'متابعة القرآن',
  parents: 'أولياء الأمور',
  grades: 'نقط الإختبارات',
  communication: 'التواصل',
  communicationTitle: 'الرسائل والتواصل',
  messages: 'الرسائل',
  emails: 'البريد الإلكتروني',
  admins: 'المديرون',
  statistics: 'الإحصائيات',
  financialManagement: 'الإدارة المالية',
  expenses: 'المداخيل و المصاريف',
  income: 'المداخيل',
  expense: 'مصروف',
  incomeTotal: 'إجمالي المداخيل',
  expenseTotal: 'إجمالي المصاريف',
  difference: 'الميزانية(المداخيل - المصاريف)',
  addFinancialRecord: 'إضافة مدخول أو مصروف',
  studentFees: 'رسوم الطلاب',
  teacherSalaries: 'رواتب الأساتذة',
  
  // Monthly contributions
  academicYear: 'السنة الدراسية',
  category: 'الفئة',
  type: 'النوع',
  totalAmount: 'المبلغ الإجمالي',
  annualEnrollment: 'الإنخراط السنوي',
  status: 'الحالة',
  notes: 'ملاحظات',
  september: 'سبتمبر',
  october: 'أكتوبر',
  november: 'نوفمبر',
  december: 'ديسمبر',
  january: 'يناير',
  february: 'فبراير',
  march: 'مارس',
  april: 'أبريل',
  may: 'مايو',
  june: 'يونيو',
  july: 'يوليو',
  august: 'أغسطس',
  paid: 'مدفوع',
  unpaid: 'غير مدفوع',
  partial: 'جزئي',
  allStudents: 'جميع الطلاب',
  allParents: 'جميع أولياء الأمور',
  allTeachers: 'جميع الأساتذة',
  total: 'المجموع',
  actions: 'الإجراءات',
  confirmDelete: 'هل أنت متأكد من الحذف؟',
  deleteSuccess: 'تم الحذف بنجاح',
  deleteError: 'خطأ في الحذف',
  
  // Common actions
  add: 'إضافة',
  edit: 'تعديل',
  delete: 'حذف',
  update: 'تحديث',
  save: 'حفظ',
  cancel: 'إلغاء',
  search: 'بحث',
  filter: 'تصفية',
  refresh: 'تحديث',
  loading: 'جاري التحميل...',
  error: 'خطأ',
  success: 'نجح',
  confirm: 'تأكيد',
  close: 'إغلاق',
  
  // Status
  active: 'نشط',
  inactive: 'غير نشط',
  
  // Student management
  addStudent: 'إضافة طالب',
  editStudent: 'تعديل طالب',
  deleteStudent: 'حذف طالب',
  studentName: 'اسم الطالب',
  studentPhone: 'رقم الهاتف',
  studentIdNumber: 'رقم البطاقة',
  studentAddress: 'العنوان',
  studentLevel: 'المستوى',
  studentHalqa: 'الحلقة',
  studentNotes: 'ملاحظات',
  studentParent: 'ولي الأمر',
  studentTeacher: 'الأستاذ',
  selectParent: 'اختر ولي الأمر',
  selectTeacher: 'اختر الأستاذ',
  studentAddedSuccess: 'تم إضافة الطالب بنجاح',
  studentUpdatedSuccess: 'تم تعديل الطالب بنجاح',
  studentDeletedSuccess: 'تم حذف الطالب بنجاح',
  studentAddError: 'خطأ في إضافة الطالب',
  studentUpdateError: 'خطأ في تعديل الطالب',
  studentDeleteError: 'خطأ في حذف الطالب',
  confirmDeleteStudent: 'هل أنت متأكد من حذف هذا الطالب؟',
  
  // Teacher management
  studentProgress: 'تقدم الطلاب',
  adminsList: 'المديرون',
  addTeacher: 'إضافة أستاذ',
  editTeacher: 'تعديل أستاذ',
  deleteTeacher: 'حذف أستاذ',
  teacherName: 'اسم الأستاذ',
  teacherUsername: 'اسم المستخدم',
  teacherPassword: 'كلمة المرور',
  teacherEmail: 'البريد الإلكتروني',
  teacherPhone: 'رقم الهاتف',
  teacherSpecialization: 'التخصص',
  teacherExperience: 'سنوات الخبرة',
  teacherHireDate: 'تاريخ التوظيف',
  teacherSalary: 'الراتب',
  teacherAssignedHalqas: 'الحلقات المخصصة',
  teacherNotes: 'ملاحظات',
  teacherAddedSuccess: 'تم إضافة الأستاذ بنجاح',
  teacherUpdatedSuccess: 'تم تحديث بيانات الأستاذ بنجاح',
  teacherDeletedSuccess: 'تم حذف الأستاذ بنجاح',
  teacherAddError: 'خطأ في إضافة الأستاذ',
  teacherUpdateError: 'خطأ في تحديث الأستاذ',
  teacherDeleteError: 'خطأ في حذف الأستاذ',
  confirmDeleteTeacher: 'هل أنت متأكد من حذف هذا الأستاذ؟',
  
  // Parent management
  addParent: 'إضافة ولي أمر',
  editParent: 'تعديل ولي أمر',
  deleteParent: 'حذف ولي أمر',
  parentName: 'اسم ولي الأمر',
  parentUsername: 'اسم المستخدم',
  parentEmail: 'البريد الإلكتروني',
  parentPhone: 'رقم الهاتف',
  parentNotes: 'ملاحظات',
  parentAddedSuccess: 'تم إضافة ولي الأمر بنجاح',
  parentUpdatedSuccess: 'تم تحديث بيانات ولي الأمر بنجاح',
  parentDeletedSuccess: 'تم حذف ولي الأمر بنجاح',
  parentAddError: 'خطأ في إضافة ولي الأمر',
  parentUpdateError: 'خطأ في تحديث ولي الأمر',
  parentDeleteError: 'خطأ في حذف ولي الأمر',
  confirmDeleteParent: 'هل أنت متأكد من حذف هذا ولي الأمر؟',
  
  // Admin management
  addAdmin: 'إضافة مدير',
  editAdmin: 'تعديل مدير',
  deleteAdmin: 'حذف مدير',
  adminName: 'اسم المدير',
  adminUsername: 'اسم المستخدم',
  adminPassword: 'كلمة المرور',
  adminPasswordConfirm: 'تأكيد كلمة المرور',
  adminEmail: 'البريد الإلكتروني',
  adminPhone: 'رقم الهاتف',
  adminPermissions: 'الصلاحيات',
  adminNotes: 'ملاحظات',
  adminAddedSuccess: 'تم إضافة المدير بنجاح',
  adminUpdatedSuccess: 'تم تحديث بيانات المدير بنجاح',
  adminDeletedSuccess: 'تم حذف المدير بنجاح',
  adminAddError: 'خطأ في إضافة المدير',
  adminUpdateError: 'خطأ في تحديث بيانات المدير',
  adminDeleteError: 'خطأ في حذف المدير',
  confirmDeleteAdmin: 'هل أنت متأكد من حذف هذا المدير؟',
  
  // Grade management
  addGrade: 'إضافة درجة',
  editGrade: 'تعديل درجة',
  deleteGrade: 'حذف درجة',
  gradeStudent: 'الطالب',
  gradeSubject: 'المادة',
  gradeValue: 'الدرجة',
  gradeDate: 'التاريخ',
  gradeComment: 'التعليق',
  student: 'الطالب',
  studentLabel: 'الطالب/ـة',
  subject: 'المادة',
  grade: 'الدرجة',
  date: 'التاريخ',
  comment: 'التعليق',
  selectStudent: 'اختر الطالب',
  selectSubject: 'اختر المادة',
  gradeAddedSuccess: 'تم إضافة الدرجة بنجاح',
  gradeDeletedSuccess: 'تم حذف الدرجة بنجاح',
  gradeAddError: 'خطأ في إضافة الدرجة',
  gradeDeleteError: 'خطأ في حذف الدرجة',
  confirmDeleteGrade: 'هل أنت متأكد من حذف هذه الدرجة؟',
  
  // Communication
  sendMessage: 'إرسال رسالة',
  sentMessages: 'الرسائل المرسلة',
  receivedMessages: 'الرسائل المستلمة',
  emailsSending: 'البريد المرسل',
  emailsReceiving: 'البريد المستلم',
  messageRecipient: 'المستلم',
  messageSubject: 'موضوع الرسالة',
  messageContent: 'محتوى الرسالة',
  from: 'من',
  messagePriority: 'الأولوية',
  messageType: 'نوع الرسالة',
  messageSentSuccess: 'تم إرسال الرسالة بنجاح',
  messageSendError: 'خطأ في إرسال الرسالة',
  
  // Statistics
  totalStudents: 'إجمالي الطلاب',
  totalTeachers: 'إجمالي الأساتذة',
  totalParents: 'إجمالي أولياء الأمور',
  averageGrade: 'متوسط نقط الإختبارات',
  unreadMessages: 'الرسائل غير المقروءة',
  noReceivedMessages: 'لا توجد رسائل مستلمة',
  unknown: 'غير معروف',
  
  // Form validation
  required: 'مطلوب',
  invalidFormat: 'تنسيق غير صحيح',
  password: 'كلمة المرور',
  passwordMismatch: 'كلمات المرور غير متطابقة',
  unknownError: 'خطأ غير معروف',
  
  // Placeholders
  notSpecified: 'غير محدد',
  noData: 'لا توجد بيانات',
  selectOption: 'اختر خيار',
  
  // Levels
  levelKindergarten: 'الروض',
  level1: 'الأول',
  level2: 'الثاني',
  level3: 'الثالث',
  level4: 'الرابع',
  level5: 'الخامس',
  level6: 'السادس',
  levelMiddle: 'الإعدادي',
  levelSecondary: 'الثانوي',
  
  // Halqas
  halqaMemorizationBook: 'حلقة الحفظ بالمصحف',
  halqaMemorizationListening: 'حلقة الحفظ بالسمع',
  
  // Back to home
  backToHome: 'العودة للصفحة الرئيسية',
  logout: 'خروج',
  
  // Placeholders
  enterStudentName: 'أدخل اسم الطالب',
  enterPhone: 'أدخل رقم الهاتف',
  enterIdNumber: 'أدخل رقم البطاقة',
  enterAddress: 'أدخل العنوان',
  enterNotes: 'أدخل أي ملاحظات إضافية',
  enterGrade: 'أدخل الدرجة',
  enterMessageSubject: 'أدخل موضوع الرسالة',
  enterMessageContent: 'أدخل محتوى الرسالة',
  enterTeacherFullName: 'أدخل الاسم الكامل للأستاذ',
  enterAdminFullName: 'أدخل الاسم الكامل للمدير',
  enterEmail: 'أدخل البريد الإلكتروني',
  confirmPassword: 'أكد كلمة المرور',
  newPasswordOptional: 'كلمة مرور جديدة (اختياري)',
  teacherNotesOptional: 'ملاحظات حول الأستاذ (اختياري)',
  phoneFormat: '01xxxxxxxxx',
  
  // Quran Tracking
  quranTrackingTitle: 'متابعة حفظ القرآن',
  addNewRecord: 'إضافة سجل جديد',
  noStudents: 'لا يوجد طلاب',
  noStudentsFilter: 'لا يوجد طلاب مطابقين للفلتر',
  previousSessions: 'الجلسات السابقة',
  noRecords: 'لا توجد سجلات متاحة',
  editQuranRecord: 'تعديل سجل قرآن',
  addQuranRecord: 'إضافة سجل قرآن جديد',
  hide: 'إخفاء',
  show: 'عرض',
  
  // Section Paramètres
  parameters: 'الإعدادات',
  parametersSection: 'إدارة الإعدادات',
  parameterName: 'اسم الإعداد',
  parameterValue: 'القيمة',
  parameterDescription: 'الوصف',
  addParameter: 'إضافة إعداد',
  editParameter: 'تعديل الإعداد',
  deleteParameter: 'حذف الإعداد',
  parameterNamePlaceholder: 'مثال: targetRepeatNewHifzCount',
  parameterValuePlaceholder: 'أدخل القيمة',
  parameterDescriptionPlaceholder: 'أدخل الوصف (اختياري)',
  parameterNameNote: 'يجب أن يكون الاسم بصيغة تقنية بالإنجليزية (مثال: targetRepeatNewHifzCount)',
  parameterCreated: 'تم إنشاء الإعداد بنجاح',
  parameterUpdated: 'تم تحديث الإعداد بنجاح',
  parameterDeleted: 'تم حذف الإعداد بنجاح',
  confirmDeleteParameter: 'هل أنت متأكد من حذف هذا الإعداد؟',
  parameterNameRequired: 'اسم الإعداد مطلوب',
  parameterValueRequired: 'قيمة الإعداد مطلوبة',
  parameterAlreadyExists: 'إعداد بهذا الاسم موجود بالفعل',
  noParameters: 'لا توجد إعدادات',
  schoolYearSystemTitle: 'السنة الدراسية (النظام)',
  schoolYearSelectLabel: 'السنة الدراسية',
  schoolYearCalendarHint: 'افتراضياً: 1 سبتمبر → 31 أغسطس (قابل للتعديل عند الإنشاء)',
  schoolYearStartDate: 'البداية',
  schoolYearEndDate: 'النهاية',
  schoolYearClose: 'إنهاء السنة الحالية',
  schoolYearCloseTitle: 'إغلاق السنة الدراسية',
  schoolYearCloseHelp: 'ستصبح السنة الحالية للقراءة فقط. اختر السنة التي تُفعَّل.',
  schoolYearActivate: 'تفعيل السنة',
  schoolYearConfirmClose: 'إغلاق وتفعيل',
  schoolYearClosing: 'جارٍ الإغلاق…',
  schoolYearCloseNeedNew:
    'أنشئ السنة الجديدة أولاً (« سنة جديدة »)، ثم أغلق السنة الحالية.',
  schoolYearNew: 'إنشاء سنة دراسية',
  schoolYearCreate: 'إنشاء',
  schoolYearCancel: 'إلغاء',
  schoolYearCreating: 'جارٍ الإنشاء…',
  schoolYearCloseError: 'خطأ أثناء الإغلاق',
  current: 'حالية',
  closed: 'مغلقة',
  parametersGeneralSection: 'إعدادات التطبيق الأخرى',
  createdDate: 'تاريخ الإنشاء',
  updatedDate: 'آخر تحديث',

  // Dashboard stats
  refreshing: 'جارٍ التحديث…',
  refreshDashboard: 'إعادة تحميل بيانات لوحة التحكم',
  lastRefresh: 'آخر تحديث',
  statTotalStudents: 'إجمالي الطلاب',
  statPresentToday: 'الحاضرون اليوم',
  noSessionsToday: 'لا توجد جلسة',
  kpiPerimeterMismatch: 'يتم مزامنة النطاق',
  statAbsentToday: 'الغائبون اليوم',
  statPendingRequests: 'طلبات معلقة',
  statNewMessages: 'رسائل جديدة',

  // Dashboard tabs
  tabActivities: 'الأنشطة الحديثة',
  tabLastSession: 'الحضور في آخر جلسة',
  tabAttendanceByDate: 'الحضور حسب التاريخ',

  // Activity labels
  actMessageFrom: 'رسالة من',
  actUnknownSender: 'مرسل غير معروف',
  actNoContent: 'محتوى الرسالة غير متوفر',
  actUnknownDate: 'تاريخ غير معروف',
  actNoMessages: 'لا توجد رسائل حديثة',
  actNoMessagesDesc: 'لم يتم العثور على أي رسائل في النظام',
  actPendingRegistration: 'طلب تسجيل في انتظار المراجعة',
  actClickDetails: 'انقر للاطلاع على التفاصيل',
  actNewContactMessage: 'رسالة تواصل جديدة',
  actClickReply: 'انقر للرد على الرسائل',
  actTotalStudents: 'إجمالي الطلاب المسجلين',
  actStudentInSystem: 'طالب مسجل في النظام',
  actActiveTeachers: 'الأساتذة النشطين',
  actTeacherInSystem: 'أستاذ نشط في النظام',
  actNow: 'الآن',
  actPresent: 'حاضر',
  actAbsent: 'غائب',
  actSaving: 'جاري الحفظ...',

  // Generic UI
  all: 'الكل',
  male: 'ذكر',
  female: 'أنثى',
  gender: 'الجنس',
  phone: 'الهاتف',
  permissions: 'الصلاحيات',
  to: 'إلى',
  username: 'اسم المستخدم',
  adminTitle: 'المدير',
  administrationBoard: 'لوحة الإدارة',
  applicantInfo: 'معلومات مقدم الطلب',
  teacherInfoLabel: 'معلومات المعلم',
  memorizedHizb: 'حزب محفوظ',
  presentFilter: 'الحاضرون',
  absentFilter: 'الغائبون',
  allTeachersOption: 'جميع الأساتذة',

  // Empty states
  noSentMessages: 'لا توجد رسائل مرسلة',
  noAdminsRegistered: 'لا يوجد مديرين مسجلين في النظام',
  noFinancialRecords: 'لا توجد سجلات مالية مسجلة',
  noContributions: 'لا توجد مساهمات مسجلة',
  noSalaries: 'لا توجد رواتب مسجلة',
  noAccessPermission: 'ليس لديك صلاحية للوصول إلى هذا القسم',
  totalAbsences: 'مجموع الغياب',
  noTeachersRegistered: 'لا توجد أساتذة مسجلين بعد',
  inactiveFilterHint: 'عند التحديد، تُعرض أيضاً الأساتذة غير النشطين',
  noActiveTeachers: 'لا يوجد أساتذة نشطون. حدّد «غير نشط» لعرضهم',
  addTestScore: 'إضافة نقطة اختبار',
  gradeOutOf20: 'الدرجة (/20)',
  noTestScores: 'لا توجد نقط اختبار مسجلة في النظام',
  addTestScoreHint: 'اضغط على "إضافة نقطة اختبار" لإضافة نقطة جديدة',
  noSubjectsAvailable: 'لا توجد مواد متاحة',
  // Students / Parents UI
  infoSectionTitle: '📋 المعلومات',
  filters: '🔍 الفلاتر',
  selectColumns: 'اختيار الأعمدة',
  selectAll: 'تحديد الكل',
  resetFilters: 'إعادة تعيين الفلاتر',
  viewTable: 'عرض جدول',
  viewCards: 'عرض بطاقات',
  noFilterResults: 'لا توجد نتائج مطابقة للفلترة',
  tryChangingFilters: 'جرب تغيير معايير الفلترة',
  noStudentsRegistered: 'لا يوجد طلاب مسجلين في النظام',
  addStudentHint: 'اضغط على "إضافة طالب" لإضافة طالب جديد',
  noParentsRegistered: 'لا يوجد أولياء أمور مسجلين بعد',
  noFilterResultsParents: 'لا توجد نتائج للبحث',
  addParentHint: 'اضغط على "إضافة ولي أمر" لإضافة جديد',
  addNewStudent: 'إضافة طالب جديد',
  editStudentTitle: 'تعديل بيانات الطالب',
  addNewParent: 'إضافة ولي أمر جديد',
  editParentTitle: 'تعديل بيانات ولي الأمر',
  noChildrenRegistered: 'لا يوجد أبناء مسجلون',
  childrenSection: '🎓 الأبناء',
  personalInfoSection: '📋 المعلومات الشخصية',
  saveChanges: 'حفظ التعديلات',
  selectLevel: 'اختر المستوى',
  selectHalqa: 'اختر الحلقة',
  newPassword: 'كلمة المرور الجديدة',
  optional: '(اختياري)',
  sendCredentials: 'إرسال بيانات الدخول عبر:',
  saveStudent: 'حفظ الطالب',
  saveParent: 'إضافة ولي الأمر',
  errorAddingStudent: 'خطأ في إضافة الطالب',
  errorEditingStudent: 'خطأ في تعديل الطالب',
  errorAddingParent: 'خطأ في إضافة ولي الأمر',
  errorEditingParent: 'خطأ في تعديل ولي الأمر',
  noParentsAvailable: 'لا توجد أولياء أمور مسجلون في النظام',
  suspended: 'معلق',
  withdrawn: 'منسحب',
  address: 'العنوان',
  email: 'البريد الإلكتروني',
  averageTestScores: 'متوسط نقط الإختبارات',
  memorizationStatistics: 'إحصائيات الحفظ',
  memorizationLevelAdvanced: 'متقدمون',
  memorizationLevelIntermediate: 'متوسطون',
  memorizationLevelBeginner: 'مبتدئون',
  noStudentsMatchFilter: 'لا يوجد طلاب يطابقون الفلتر المحدد',

  // Quran tracking - colonnes tableau séances précédentes
  quranTableDate: 'التاريخ',
  quranTableNewHifz: 'الحفظ الجديد',
  quranTableOldMurajah: 'مراجعة الحفظ القديم',
  quranTableNewMurajah: 'مراجعة الحفظ القريب',
  quranTableEvalNewHifz: 'تقييم الحفظ',
  quranTableEvalOldMurajah: 'تقييم مراجعة الحفظ القديم',
  quranTableEvalNewMurajah: 'تقييم مراجعة الحفظ القريب',
  quranTableNote: 'الملاحظة',
  quranTableHizb: 'عدد الأحزاب',
  quranHizbLabel: 'حزب محفوظ',
  quranProgressLabel: 'تقدم الحفظ',
  quranProgressPercent: '% من القرآن',
};

